import { Shark, View } from "shark-mvc";

import templateContent from "./login.html";

import { homeView } from "../../_shark_jaws/views/homeView";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { userManager } from "../../_shark_jaws/managers/userManager";

class LoginView extends View {
	constructor () {
		super("loginView");
		this.setTemplate(templateContent);
	}

	afterRender () {
		const passwordField = document.querySelector("#passwordField");

		if (passwordField) {
			passwordField.focus();
		}
	}

	beforeLoad () {
		Shark.setURLSearchParams(null);
		const lastUserEMail = localStorage.getItem("lastUserEMail") || "";

		Shark.set("currUser", Shark.getInstance("User", { email: lastUserEMail }));
		Shark.get("currUser").set("password", "");
	}

	init () {
		this.addComponents([mainNavComponent]);
	}

	loginBtn_clickHandler () {
		this.set({
			__loginError: false,
		});

		const currUser = Shark.get("currUser");

		userManager.logIn(currUser)
		.then(this.processLogiResult);
	}
	
	passwordField_keyupHandler (event) {
		if (event.keyCode === 13) {
			event.preventDefault();
			userManager.logIn(Shark.get("currUser"))
			.then(this.processLogiResult);
			return false;
		}
	}

	processLogiResult (loginResponse) {
		console.log({loginResponse});

		const currUser = Shark.get("currUser");

		if (loginResponse.status === "ok") {
			if (currUser.hasRole(["areaManager", "sellRepresentative", "systemAdmin", "internalStaff"]) && currUser.status === 1) {
				localStorage.setItem("preserveLogin", currUser.__preserveLogin);
				localStorage.setItem("lastUserEMail", currUser.email);
			
				Shark.openPage(homeView);
			}
			else {
				alert("Non hai il permesso di entrare qui...");
			}
		}
		else {
			loginView.set({
				__loginError: true,
			});
			Shark.render();
		}
	}
}

const loginView = new LoginView();

Shark.registerView(loginView);

export default loginView;
